import { Input, Inject, Optional, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SVG_SPRITE_URL } from './svg-icon.module';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  @Input()
  name?: string;

  constructor(@Optional() @Inject(SVG_SPRITE_URL) public spriteUrl: string | null) {}
}
